export default "__VITE_ASSET__idjEhyvn__"